/**
 * This is a simple loading animation.
 * This code is protected under the MIT license (see the LICENSE file).
 * @author Zenzicubic
 */

import React from 'react';

import './loading-animation.css';

function Loading() {
    return (<div className="loader"></div>);
}

export default Loading;